var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCountryDo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 20,
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2858_8404)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.25 2C0.25 1.0335 1.0335 0.25 2 0.25H26C26.9665 0.25 27.75 1.0335 27.75 2V18C27.75 18.9665 26.9665 19.75 26 19.75H2C1.0335 19.75 0.25 18.9665 0.25 18V2Z",
    fill: "white",
    stroke: "#F5F5F5",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2858_8404",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 28,
    height: 20
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.25 2C0.25 1.0335 1.0335 0.25 2 0.25H26C26.9665 0.25 27.75 1.0335 27.75 2V18C27.75 18.9665 26.9665 19.75 26 19.75H2C1.0335 19.75 0.25 18.9665 0.25 18V2Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2858_8404)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 8H12V0H0V8Z",
    fill: "#083D7A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 20H28V12H16V20Z",
    fill: "#083D7A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 20H12V12H0V20Z",
    fill: "#DF1E35"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 8H28V0H16V8Z",
    fill: "#DF1E35"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-8-inside-1_2858_8404",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5858 8.58579C11.8048 9.36684 11.8048 10.6332 12.5858 11.4142C13.3669 12.1953 14.6332 12.1953 15.4143 11.4142C16.1953 10.6332 16.1953 9.36683 15.4143 8.58579"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M12.1144 8.11438C11.073 9.15578 11.073 10.8442 12.1144 11.8856L13.0572 10.9428C12.5365 10.4221 12.5365 9.57789 13.0572 9.05719L12.1144 8.11438ZM12.1144 11.8856C13.1558 12.927 14.8443 12.927 15.8857 11.8856L14.9429 10.9428C14.4222 11.4635 13.5779 11.4635 13.0572 10.9428L12.1144 11.8856ZM15.8857 11.8856C16.9271 10.8442 16.9271 9.15578 15.8857 8.11438L14.9429 9.05719C15.4636 9.57789 15.4636 10.4221 14.9429 10.9428L15.8857 11.8856Z",
    fill: "#0F6D1A",
    mask: "url(#path-8-inside-1_2858_8404)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9999 10.6667C14.3681 10.6667 14.6666 10.3682 14.6666 10C14.6666 9.63185 14.3681 9.33337 13.9999 9.33337C13.6317 9.33337 13.3333 9.63185 13.3333 10C13.3333 10.3682 13.6317 10.6667 13.9999 10.6667Z",
    fill: "#042F60"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2858_8404"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 2C0 0.895431 0.895431 0 2 0H26C27.1046 0 28 0.895431 28 2V18C28 19.1046 27.1046 20 26 20H2C0.895431 20 0 19.1046 0 18V2Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCountryDo);
export default __webpack_public_path__ + "static/media/Country=DO.c37fa1bb0737451e43dce5574db7f98d.svg";
export { ForwardRef as ReactComponent };